<template>
  <div class="box_steps" >
    <div class="items_step" v-for="(item, index) in list_data_process" :key="index">
      <div class="box_circle_step" >
        <img class="img_circle" :src="(item.key_active == 0) ? img_circle_inactive: img_circle_active"/>
        <span class="step_number_text">{{ index+1 }}</span>
      </div>
      <span class="title_step" :style="(item.key_active == 0) ? 'color: rgba(102, 102, 102, 0.866666666666667);':'color: #2196F3;'" >{{ item.title }}</span>
      <img v-if="index != (list_data_process.length-1)" class="strikethrough_step" :src="(item.key_active == 1 && list_data_process[index+1].key_active == 1) ? strikethrough_step_active:strikethrough_step_inactive" />
      <!--item.key_active == 1 && list_data_process[index+1].key_active == 1 => check điều kiện active và key tiếp theo active thì mới hiển thị-->
    </div>
    <!--<div class="items_step">
      <div class="box_circle_step" >
        <img class="img_circle" :src="(step_active < 1) ? img_circle_inactive: img_circle_active"/>
        <span class="step_number_text">1</span>
      </div>
      <span class="title_step" :style="(step_active < 1) ? 'color: rgba(102, 102, 102, 0.866666666666667);':'color: #2196F3;'" >Tiếp nhận</span>
      <img class="strikethrough_step" :src="(step_active < 2) ? strikethrough_step_inactive:strikethrough_step_active" />
    </div>
    <div class="items_step">
      <div class="box_circle_step" >
        <img class="img_circle" :src="(step_active < 2) ? img_circle_inactive: img_circle_active"/>
        <span class="step_number_text">2</span>
      </div>
      <span class="title_step" :style="(step_active < 2) ? 'color: rgba(102, 102, 102, 0.866666666666667);':'color: #2196F3;'" >Kiểm tra & thực hiện</span>
      <img class="strikethrough_step" :src="(step_active < 3) ? strikethrough_step_inactive:strikethrough_step_active" />
    </div>
    <div class="items_step">
      <div class="box_circle_step" >
        <img class="img_circle" :src="(step_active < 3) ? img_circle_inactive: img_circle_active"/>
        <span class="step_number_text">3</span>
      </div>
      <span class="title_step" :style="(step_active < 3) ? 'color: rgba(102, 102, 102, 0.866666666666667);':'color: #2196F3;'" >Giao trả</span>
      <img class="strikethrough_step" :src="(step_active < 4) ? strikethrough_step_inactive:strikethrough_step_active" />
    </div>
    <div class="items_step">
      <div class="box_circle_step" >
        <img class="img_circle" :src="(step_active < 4) ? img_circle_inactive: img_circle_active"/>
        <span class="step_number_text">4</span>
      </div>
      <span class="title_step" :style="(step_active < 4) ? 'color: rgba(102, 102, 102, 0.866666666666667);':'color: #2196F3;'" >Hoàn thành</span>
      &lt;!&ndash;<img class="strikethrough_step" :src="(step_active < 2) ? strikethrough_step_inactive:strikethrough_step_active" />&ndash;&gt;
    </div>-->
  </div>
</template>

<script>
    export default {
        props: {
          status_active: {
            type: Number,
            default: 0
          },
          list_process: Array,
        },
        data() {
            return {
              img_circle_active: window.origin + '/assets/images/circle_active.png',
              img_circle_inactive: window.origin + '/assets/images/circle_inactive.png',
              strikethrough_step_active: window.origin + '/assets/images/strikethrough_step_active.png',
              strikethrough_step_inactive: window.origin + '/assets/images/strikethrough_step_inactive.png',
              list_data_process:[]
            }
        },
      async mounted() {
        await this.initData();
      },
      async created() {
        await this.initData();
      },
      methods: {
        initData() {
          var list_process_data = [];
          var key_active = 1;
          for (var i = 0;i < this.list_process.length;i++){
            var dataItem = this.list_process[i];
            dataItem.key_active = key_active;
            list_process_data.push(dataItem);
            if (this.list_process[i].process_status == this.status_active){
              key_active = 0;
            }
          }
          //console.log("list_process_data:",list_process_data)
          this.list_data_process = list_process_data;
        }
      },
    }
</script>

<style lang="scss">
.box_steps{
  padding: 27px 0px;
  //center step
  display: flex; justify-content: center; align-items: center;
  .items_step{
    display: inline-block;margin-right: 14px;
    .box_circle_step{
      display: inline-block;width: 49px;height: 49px;position: relative;
      .img_circle{
        margin-top: -10px;width: 49px;height: 49px
      }
      .step_number_text{
        position: absolute;margin: auto;top:0px;left: 0px;bottom: 0px;right: 0px;width: fit-content;font-weight: 700; font-style: normal; font-size: 20px; color: #FFFFFF;
      }
    }
    .title_step{
      margin-left: 11px;margin-right: 11px;font-weight: 700; font-style: normal; font-size: 18px; color: rgba(102, 102, 102, 0.866666666666667);
    }
    .strikethrough_step{
      width: 65px;
      height: 9px;
    }
  }
}
</style>